import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentIconSkeleton } from './TypeComponentIcon'
import type { TypeComponentLinkSkeleton } from './TypeComponentLink'

export interface TypeComponentCtaLinkFields {
  internalName?: EntryFieldTypes.Symbol
  label?: EntryFieldTypes.Symbol
  link: EntryFieldTypes.EntryLink<TypeComponentLinkSkeleton>
  style: EntryFieldTypes.Symbol<'Arrow Link' | 'Button: Outlined' | 'Button: Solid' | 'Plain Link'>
  bold?: EntryFieldTypes.Boolean
  icon?: EntryFieldTypes.EntryLink<TypeComponentIconSkeleton>
  iconPosition?: EntryFieldTypes.Symbol<'Left' | 'Right'>
  size?: EntryFieldTypes.Symbol<'Base' | 'Larger' | 'Smaller'>
  display?: EntryFieldTypes.Symbol<'Block' | 'Inline'>
  downloadFile?: EntryFieldTypes.AssetLink
  plausibleEventName?: EntryFieldTypes.Symbol
}

export type TypeComponentCtaLinkSkeleton = EntrySkeletonType<TypeComponentCtaLinkFields, 'componentCtaLink'>
export type TypeComponentCtaLink<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentCtaLinkSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentCtaLink<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentCtaLink<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentCtaLink'
}
